import type { QuotaCounterStatus, QuotaStatusResponse } from '../types';

export type QuotaTone = 'normal' | 'warning' | 'critical';

export function quotaTone(percentage: number): QuotaTone {
  if (percentage > 90) return 'critical';
  if (percentage > 75) return 'warning';
  return 'normal';
}

export interface NamedQuota {
  key: string;
  label: string;
  value: QuotaCounterStatus;
}

/**
 * Les cinq compteurs, dans l'ordre de ce qu'ils coutent reellement.
 *
 * Cet ordre n'est pas decoratif : il sert de departage quand deux compteurs
 * sont a egalite (typiquement a zero, en debut de mois). C'est donc « Recherche
 * ciblee » qui s'affiche par defaut — le seul dont un depassement se facture.
 */
export function quotaCounters(status: QuotaStatusResponse): NamedQuota[] {
  return [
    { key: 'text-search', label: 'Recherche ciblee', value: status.placesTextSearch },
    { key: 'nearby', label: 'Toutes categories', value: status.placesNearbySearch },
    { key: 'details', label: 'Fiches actualisees', value: status.placesDetails },
    { key: 'geocoding', label: 'Adresses', value: status.geocoding },
    { key: 'pagespeed', label: 'Analyses de site', value: status.pagespeed },
  ];
}

/**
 * Le compteur le plus proche de son plafond — celui qui coupera le service en
 * premier, et donc la seule lecture qui informe vraiment.
 *
 * La comparaison porte sur le **pourcentage**, jamais sur les valeurs brutes :
 * les cinq compteurs n'ont pas la meme echelle (950 pour les recherches,
 * 9 500 pour les adresses, 2 000 pour PageSpeed). Comparer les nombres bruts
 * ferait toujours gagner les adresses, et les additionner donnerait un chiffre
 * rassurant et faux.
 */
export function busiestQuota(status: QuotaStatusResponse): NamedQuota {
  const counters = quotaCounters(status);
  return counters.reduce((pire, candidat) =>
    // Strictement superieur : a egalite, le premier declare l'emporte.
    candidat.value.percentage > pire.value.percentage ? candidat : pire,
  );
}
